export default {
        head: {
            aboutus: "<p>惠智采智能采购综合管理平台</p>",
            address: "",
            citycode: "0",
            guid: "AEE20DFD3BC94C2D8CB7FCF173D88137",
            icp: "冀ICP备14012003号-3",
            icp2: "冀公网安备 13010402001763号",
            logofileguid: "",
            logourl:"/images/logo.png",
            meta: "惠智采智能采购综合管理平台",
            planname: "hzc",
            tel: "400-780-9998",
            title: "惠智采智能采购综合管理平台",
            address:'河北省石家庄市桥西区中山东路126号凯嘉大厦10楼'
        },
        personlist: [
            {
                imgsrc: '/img/login/cg.png',
                href: 'http://dl.smartprocure.cn/otc/#/login?plan=hzc&mRole=tender',
                con: '采购人登录'
            },
            {
                imgsrc: '/img/login/zb.png',
                href: 'http://dl.smartprocure.cn/otc/#/login?plan=hzc&mRole=agent',
                con: '招标代理登录'
            },
            {
                imgsrc: '/img/login/tb.png',
                href: 'http://tb.smartprocure.cn/newtbr/index.html#/login?plan=hzc',
                con: '投标人登录'
            },
            {
                imgsrc: '/img/login/pb.png',
                href: 'http://pb.smartprocure.cn/feature/hzc?plan=hzc',
                con: '评标登录'
            }
        ],
      
    }
    